import React from 'react';
import FramiSvgIcon from './FramiSvgIcon';

function FilterIcon(props) {
    return (
        <FramiSvgIcon {...props} viewBox="0 0 24 24">
            <path d="M10 18V16H14V18H10ZM6 13V11H18V13H6ZM3 8V6H21V8H3Z" />
        </FramiSvgIcon>
    );
}

export default FilterIcon;
